export default {
  state: {
    defaultModalData: {
      data: null,
      type: "CREATE",
      status: false,
      componentName: "",
    },
    isEdit: false
  },

  getters: {
    getDefaultModalData(state) {
      return state.defaultModalData;
    },
    getIsEditData(state){
      return state.isEdit;
    }
  },

  mutations: {
    setDefaultModalInfos(state, infos) {
      state.defaultModalData.data = infos.data;
      state.defaultModalData.type = infos.data === null ? "CREATE" : "EDIT";
      state.defaultModalData.status = infos.status;
      state.defaultModalData.componentName = infos.componentName;
    },
    setIsEditData(state, data){
      state.isEdit = data
    }
  },

  actions: {
    changeDefaultModalInfos(context, infos) {
      context.commit("setDefaultModalInfos", infos);
    },

    changeIsEditData(context, data){
      context.commit("setIsEditData", data)
    }
  },
};
